<template>
    <v-container
            fluid
            id="tracking"
            tag="section"
    >
        <!-- Search Bar-->

        <!-- Shipping Detail Table -->
        <v-row
                align="center"
                justify="center"
        >
            <v-col cols="12">

                <base-material-card
                        color='blue-grey darken-3'
                >
                    <template v-slot:heading>
                        <div class="display-2 font-weight-light">
                            Track Shipment Detail
                        </div>

                        <!--            <div class="subtitle-1 font-weight-light">-->
                        <!--              All details related to this shipment are listed below-->
                        <!--            </div>-->
                    </template>

                    <v-card-text>
                        <v-container
                                class="pa-0"
                                fluid
                        >
                            <v-row align="center">
                                <v-col cols="3"/>
                                <v-col cols="6">
                                    <v-text-field
                                            :label="$t('search')"
                                            v-model="search_term"
                                            color="secondary"
                                            hide-details
                                            :loading="loading"
                                            @keyup.enter="search()"
                                    >
                                        <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:append-outer>
                                            <v-btn class="mt-n2" elevation="1" fab small @click="search()">
                                                <v-icon>mdi-magnify</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3"/>
                            </v-row>
                            <v-row

                                    align="center"
                                    v-if="showInfo"
                            >
                                <v-col cols="12">
                                    <div class="subtitle-1 font-weight-light">
                                        All details related to this shipment are listed below
                                    </div>
                                </v-col>
                                <v-col :key="i"
                                       cols="12"
                                       :md="t.md"
                                       v-for="(t, i) in bookingDisplayFields"
                                >

                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-label><span class="black--text">{{t.text}}</span></v-label>
                                            <v-label><span class="blue-grey--text">{{t.decor(booking[t.id])}}</span></v-label>
                                        </v-col>
                                    </v-row>

                                </v-col>

                                <v-expansion-panels
                                        popout
                                        hover
                                        class="mb-8"
                                >
                                    <v-expansion-panel
                                            class="mt-1"
                                    >
                                        <v-expansion-panel-header color="blue-grey lighten-1 white--text">Shipping
                                            Bills
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <shipping-bill-resource :booking_id="bookingId" read-only="true"/>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>

                            </v-row>
                            <v-row v-if="showNotFound">
                                <v-col cols="3"/>
                                <v-col cols="6">
                                    <base-material-alert
                                            color="error"
                                            dark
                                            dismissible
                                            icon="mdi-bell"
                                    >
                                        We are unable to find any booking with Booking Number or B/L Number:
                                        {{search_term}}
                                    </base-material-alert>
                                </v-col>
                                <v-col cols="3"/>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>

        <!-- Tracking View -->
        <v-row v-if="showInfo">
            <v-col cols="0" md="3"/>

            <v-col cols="12" md="6">
                <v-timeline>
                    <v-timeline-item
                            :color="getColor(event)"
                            :icon="getIcon(event)"
                            :key="i"
                            fill-dot
                            v-for="(event, i) in journey"
                    >
                        <template v-slot:opposite>
          <span :class="`font-weight-bold h4 ${getColor(event)}--text`">
            {{getDisplayDate(event.timestamp)}}</span>
                        </template>

                        <div class="py-4 ">
                            <h2 :class="`H3 font-weight-light mb-4`" :style="`color:${getColor(event)}`">
                                {{getDisplayText(event)}}</h2>

<!--                            <v-alert-->
<!--                                    v-if="event.remark"-->
<!--                                    :color="getColor(event)"-->
<!--                                    :value="true"-->
<!--                                    elevation=9-->
<!--                                    class="white&#45;&#45;text"-->
<!--                            >-->
<!--                                &lt;!&ndash;                {{note.displayText}}&ndash;&gt;-->
<!--                                {{event.remark}}-->
<!--                            </v-alert>-->

                        </div>
                    </v-timeline-item>
                </v-timeline>

            </v-col>
            <v-col cols="0" md="3"/>
        </v-row>

    </v-container>
</template>

<script>

  import ResourceAPI from "../../../api/resource_api";
  import {JOURNEY_DECORATIONS} from "../../../modals/journey";
  import DateTimeHelper from "../../../helpers/datetime";
  import searchAPI from "../../../api/search_api";

  import ShippingBillResource from "./../components/resources/ShippingBill";

  export default {
    name: 'Tracking',
    components: {ShippingBillResource},
    data: () => ({
      resource: "journey",
      journey: [],
      search_term: '',
      loading: false,
      showInfo: false,
      showNotFound: false,
      decoration: JOURNEY_DECORATIONS,
      booking: null,
      bookingId: null,
      bookingDisplayFields: [
        {md: '6', id: "id", text: "Booking: ", decor: x => x},
        {md: '6', id: "shipper", text: "Shipper: ", decor: x => x},
        {md: '6', id: "port_of_loading", text: "Origin: ", decor: x => x},
        {md: '6', id: "port_of_discharge", text: "Destination: ", decor: x => x},
        {md: '6', id: "bill_of_lading", text: "Bill Of Landing: ", decor: x => x},
        {md: '6', id: "invoice_number", text: "Shippers Invoice Number: ", decor: x => x},
        {md: '6', id: "eta", text: "ETA: ", decor: x => x && DateTimeHelper.getDisplayDate(x) || 'N/A'},
        {md: '6', id: "etd", text: "ETD: ", decor: x => x && DateTimeHelper.getDisplayDate(x) || 'N/A'},
        {md: '6', id: "place_of_receipt", text: "Place Of Receipt: ", decor: x => x},
        {md: '6', id: "last_modified_at", text: "Last Updated: ", decor: x => DateTimeHelper.getDisplayDateTime(x)},
      ]
    }),
    mounted() {
    },
    methods: {
      async getData(id) {
        //this.loading = true;
        const {data} = await ResourceAPI.list({resource: this.resource, booking_id: id})
        const items = data.Items && data.Items.sort((a, b) => new Date(b.date) - new Date(a.date)) || []
        this.journey = items.map(x => ({type: x.type, remark: x.remark || "", timestamp: x.date}))
        //this.loading = false;
      },
      getColor({type}) {
        return this.decoration[type] && this.decoration[type].color || 'primary'
      },
      getIcon({type}) {
        return this.decoration[type] && this.decoration[type].icon || 'setting'
      },
      getDisplayText({type}) {
        return this.decoration[type] && this.decoration[type].displayText || ''
      },
      getDisplayDate(date) {
        return DateTimeHelper.getDisplayDate(date);
      },
      getDisplayDateTime(date) {
        return DateTimeHelper.getDisplayDateTime(date);
      },
      search() {
        this.showInfo = false;
        if (this.search_term) {
          this.loading = true;
          searchAPI.search({q: this.search_term}).then(({data}) => {
            if (data && data.Items && data.Items.length == 1) {
              // this.search_term = ''
              this.showInfo = true;
              this.showNotFound = false;
              this.booking = data.Items[0];
              this.bookingId = data.Items[0].id;
              this.getData(data.Items[0].id);
            } else {
              this.showNotFound = true;
              this.showInfo = false;
            }
            this.loading = false;
          })
        }
      }

    }
  }
</script>
